// components/HotOffers.jsx
import React, { useState ,useContext} from "react";
import { useNavigate } from "react-router-dom";
import { FaFire, FaHome, FaBuilding,  FaHouseUser, FaStore } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropertyCard from "../../../components/Shared/PropertyCard";
import { useTranslateKey } from "../../../components/translation/useTranslateKey";
import { LangContext } from "../../../components/translation/langugeContext";

const HotOffers = ({ hotOffers, projects,Property_categories}) => {
  const navigate = useNavigate();
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [hotOfferStatus, setHotOfferStatus] = useState("resale");
  const [hotOfferCategory, setHotOfferCategory] = useState(1);
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);
  const handleClick = () => {
    // Get the selected category object
    const category = Property_categories.find(
      (cat) => cat.id === hotOfferCategory
    );
  
    // If no category found (edge case), just return
    if (!category) return;
  
    // Get all type_en values from the selected category
    const defaultTypes = category.types.map((type) => type.id);
  
    // Use selected type if one is chosen, otherwise use all types of the selected category
    const selectedTypes = selectedPropertyType
      ? [selectedPropertyType]
      : defaultTypes;
  
    const params = new URLSearchParams();
    params.set("filter_type", "hot");
    params.set("property_status", hotOfferStatus);
    params.set("new_property_category", hotOfferCategory);
  
    // Add all property types from the selected category
    selectedTypes.forEach((type) =>
      params.append("new_property_type", type)
    );
  
    navigate(`/property-browser?${params.toString()}`);
  };


  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section
      id="hot-offers"
      className="mt-24 pb-16 bg-gradient-to-b from-[#121525] via-[#121525]/95 to-[#121525] relative"
    >
      <div className="container mx-auto px-4">
        {/* Three-column layout for toggles and title */}
        <div className="hot-offer-header">
          {/* Left Toggle (Primary/Resale) */}
          {/* Center Title */}
          <div className="hot-offer-title text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <FaFire
                className="inline icon-spacing"
                style={{ color: "#ff0000", fontSize: "1.2em" }}
              />
              <span>
                <span style={{ color: "#ff0000", fontWeight: "800" }}>{t("hot")}</span>{" "}
                <span style={{ color: "#F9C835", fontWeight: "800" }}>
                  {t("offers")}
                </span>
              </span>
            </h2>
            <p className="text-gray-300 text-lg mb-8">
              {t("hot_Description")}
            </p>
          </div>

          <div className="hot-offer-filters">
            <div className="flex justify-center md:justify-start">
              <div className="bg-[#11132F]/50 backdrop-blur-lg rounded-lg flex items-center p-1">
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="hotOfferStatus"
                    id="hotOfferResale"
                    className="hidden"
                    checked={hotOfferStatus === "resale"}
                    onChange={() => setHotOfferStatus("resale")}
                  />
                  <label
                    htmlFor="hotOfferResale"
                    className={`property-toggle-btn cursor-pointer px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-4 transition-all duration-300 ${
                      hotOfferStatus === "resale" ? "primary-active" : ""
                    }`}
                  >
                    <FaHome />
                    {t("resaleLabel")}
                  </label>
                  <input
                    type="radio"
                    name="hotOfferStatus"
                    id="hotOfferPrimary"
                    className="hidden"
                    checked={hotOfferStatus === "primary"}
                    onChange={() => setHotOfferStatus("primary")}
                  />
                  <label
                    htmlFor="hotOfferPrimary"
                    className={`property-toggle-btn cursor-pointer px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-4 transition-all duration-300 ${
                      hotOfferStatus === "primary" ? "primary-active" : ""
                    }`}
                  >
                    <FaBuilding />
                    {t("primaryLabel")}
                  </label>
                </div>
              </div>
            </div>

            {/* Right Toggle (Residential/Commercial) */}
            <div className="flex justify-center md:justify-end">
              <div className="bg-[#11132F]/50 backdrop-blur-lg rounded-lg flex items-center p-1">
                <div className="flex items-center">
                  {Property_categories?.map((category) => (
                    <React.Fragment key={category.id}>
                      <input
                        type="radio"
                        name="hotOfferCategory"
                        id={`hotoffer-category-${category.id}`}
                        className="hidden"
                        checked={hotOfferCategory === category.id}
                        onChange={() => {setHotOfferCategory(category.id)
                          setSelectedPropertyType("");
                        }}
                      />
                      <label
                        htmlFor={`hotoffer-category-${category.id}`}
                        className={`property-toggle-btn cursor-pointer px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-4 transition-all duration-300 ${
                          hotOfferCategory === category.id ? "primary-active" : ""
                        }`}
                      >
                        {/* Icon (fallback if not provided) */}
                        {category.category_en === "Residential" ? <FaHouseUser /> : <FaStore />}
                        {lang === "ar" ? category.category_ar:category.category_en}
                      </label>
                    </React.Fragment>
                  ))}
              </div>
              </div>
            </div>
          </div>
        </div>

        {hotOffers && hotOffers.length > 0 ? (
          <Slider {...sliderSettings}>
            {hotOffers.map((offer) => (
              <div key={offer.id} className="px-2">
                {" "}
                {/* Add padding between slides */}
                <PropertyCard
                  property={offer}
                  projects={projects}
                  customClass={lang === "ar" ? "flags-container-home-ar" : "flags-container-home"}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <div className="col-span-full text-center text-white py-12">
           {t("noOffersFound")}
          </div>
        )}
      </div>
      <div className="view-all-btn-container">
        <button
          onClick={() => handleClick()}
          className="view-all-btn cursor-pointer rounded-lg text-sm font-medium flex transition-all duration-300 primary-active"
        >
          {t("viewAllHotOffersLabel")}
        </button>
      </div>
    </section>
  );
};

export default HotOffers;
